import { Storybook } from "@tento-ui/ui/storybook";
import { DshTurnPlan } from "./plan";

export class DshTurnPlanStoryBook extends Storybook.Default {
  title(): string {
    return "Turn dsh · plan";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Mid-plan — the running step is the subject",
        render: () =>
          DshTurnPlan.makeWith({
            steps: [
              { step: "confirm seq is per-pane, not per-session", status: "done" },
              { step: "merge lanes on a parsed clock instead", status: "done" },
              {
                step: "keep turn state per lane so closeTurn cannot cross",
                status: "running",
              },
              {
                step: "re-check session 52738, the regression fixture",
                status: "pending",
              },
            ],
          }),
      },
      {
        title: "Nothing running yet — the first pending step is the subject",
        render: () =>
          DshTurnPlan.makeWith({
            steps: [
              { step: "Verify the navigator design against runtime seams", status: "done" },
              { step: "Implement the pane anchor/tail mechanism", status: "pending" },
              { step: "Run focused integration checks", status: "pending" },
            ],
          }),
      },
      {
        title: "Finished — the last step stays the subject",
        render: () =>
          DshTurnPlan.makeWith({
            steps: [
              { step: "Rebuild and smoke the preview", status: "done" },
              { step: "Land the messages header as attach-scene policy", status: "done" },
            ],
          }),
      },
      {
        title: "Single step",
        render: () =>
          DshTurnPlan.makeWith({
            steps: [{ step: "Rebuild and smoke the preview", status: "done" }],
          }),
      },
      {
        title: "A long step — the subject ellipsises, the count does not move",
        render: () =>
          DshTurnPlan.makeWith({
            steps: [
              { step: "confirm seq is per-pane", status: "done" },
              {
                step:
                  "rewrite visibleRecords as a k-way merge over already-ordered lane streams, keyed on a parsed timestamp rather than a compared string",
                status: "running",
              },
              { step: "re-check session 52738", status: "pending" },
            ],
          }),
      },
      {
        title: "Empty",
        render: () => DshTurnPlan.makeWith({ steps: [] }),
      },
    ];
  }
}
